/**
 * @generated SignedSource<<06f851777743057e5782a0527595c294>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type createOrEditPaletteDialog_paletteQuery$variables = {
  paletteId: string;
};
export type createOrEditPaletteDialog_paletteQuery$data = {
  readonly palette: {
    readonly id: string;
    readonly isZakekeDefault: boolean;
    readonly name: string;
    readonly paletteTypeID: number;
    readonly useConversionTable: boolean;
  } | null;
};
export type createOrEditPaletteDialog_paletteQuery = {
  response: createOrEditPaletteDialog_paletteQuery$data;
  variables: createOrEditPaletteDialog_paletteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "paletteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "paletteId"
      }
    ],
    "concreteType": "Palette",
    "kind": "LinkedField",
    "name": "palette",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useConversionTable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paletteTypeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isZakekeDefault",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOrEditPaletteDialog_paletteQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "createOrEditPaletteDialog_paletteQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "96d339d18a21862999976cfa16a35419",
    "id": null,
    "metadata": {},
    "name": "createOrEditPaletteDialog_paletteQuery",
    "operationKind": "query",
    "text": "query createOrEditPaletteDialog_paletteQuery(\n  $paletteId: ID!\n) {\n  palette(id: $paletteId) {\n    id\n    name\n    useConversionTable\n    paletteTypeID\n    isZakekeDefault\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7e012046791e7f269e6abebfd7a556f";

export default node;
